
export const OnboardModule = {
  namespaced: true,
  state: {
    group: '',
    description: '',
    fname: '',
    timezone: '',
    geoloc: '',
    cameras: [
      { id: 0 },
    ],
    streams: {

    },
    defaultType: undefined,
    defaultManufacturer: 'Choose a manufacturer',
  },
  mutations: {
    setDomain: (state, payload) => {
      state.group = payload.group
      state.description = payload.description
      state.fname = payload.fname
      state.timezone = payload.timezone
      state.geoloc = payload.geoloc
    },
    addCamera: (state) => {
      // push camera object onto array.
      const lastCamera = state.cameras[state.cameras.length - 1]
      const id = {
        id: (() => parseInt(Math.random() * 1000))(),
      }
      const newCamera = Object.assign({}, lastCamera, id)

      state.cameras.push(newCamera)
    },
    setCameraFields: (state, payload) => {
      const camera = state.cameras.find(camera => camera.id === payload.cameraId)
      camera[payload.fieldId] = payload.value
    },
    setAddressAndPort: (state, payload) => {
      state.addressAndPorts.push(payload)
    },
    // if your deleting one camera you need to remove the stream as well
    deleteCameraAndStream: (state, index) => {
      const cameraDelete = state.cameras.splice(index, 1)
      delete state.streams[`index-${cameraDelete[0].id}`]
    },
    // if you are editing the camera you MAY need to edit the stream as well)
    editCamera: (state, payload) => {
      const index = state.cameras.findIndex(camera => camera.id === payload.index)
      state.cameras.splice(index, 1, payload.camera)
      state.streams[`index-${payload.index}`] = [payload.stream, payload.highStream].filter(stream => !!stream)
    },
    setDefaultManufacturer: (state, manufacturer) => {
      state.defaultManufacturer = manufacturer
    },
    setDefaultType: (state, type) => {
      state.defaultType = type
    },
  },
  getters: {
    domainName: state => state.fname,
    description: state => state.description,
    timezone: state => state.timezone,
    geoloc: state => state.geoloc,
    cameras: state => state.cameras,
    streams: state => state.streams,
    defaultManufacturer: state => state.defaultManufacturer,
    defaultType: state => state.defaultType,
  },
}
